import blob_red_right from '../images/blob_red_2.svg';
import blob_green_left from '../images/blob_green_1.svg';
import blob_green_right from '../images/blob_green_2.svg';
import blob_green_bottom from '../images/blob_green_4.svg';

export const BLOBIMAGES = [
    blob_red_right,
    blob_green_left,
    blob_green_right,
    blob_green_bottom,
];

export const BLOBS = {
    RED_RIGHT: 0,
    GREEN_LEFT: 1,
    GREEN_RIGHT: 2,
    GREEN_BOTTOM: 3,
};
